// Tiny pub/sub so api.js (no React) can tell BillingBlockedModal (React) that
// the backend answered 402. One modal subscribes in App.js.
const listeners = new Set();

export const DEFAULT_BLOCKED_MESSAGE = 'Your agency cannot start new work right now.';

export function onBillingBlocked(cb) {
    listeners.add(cb);
    return () => listeners.delete(cb);
}

export function emitBillingBlocked(payload) {
    // Snapshot so a subscriber that unsubscribes mid-emit cannot skip a sibling;
    // isolate so one throwing subscriber cannot block the rest.
    [...listeners].forEach((cb) => {
        try { cb(payload); } catch (e) { console.error('billingBlocked subscriber failed:', e); }
    });
}

export function isBillingBlockedError(err) {
    return err?.response?.status === 402;
}

/** Normalises A3's body {error, code, facility_id} -> {code, message, facilityId}. */
export function billingBlockedFromError(err) {
    const data = err?.response?.data ?? {};
    return {
        code: data.code ?? 'billing_inactive',
        message: data.error ?? data.detail ?? DEFAULT_BLOCKED_MESSAGE,
        facilityId: data.facility_id ?? null,
    };
}
